<template>
    <div>
        <div style="margin:0 -12px;'">
            <div class="luna-header-box">
                <div class="container-fluid">
                    <div class="row luna-page-profile-header">
                        <div class="col-1 px-0">
                            <i class="bi bi-chevron-left" onclick="window.location.href = '/home'"></i>
                        </div>
                        <div class="col text-center">
                            プロフィール
                        </div>
                        <div class="col-1">
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div style="height:56px;"></div>
        <div class="" style="margin:0 -12px;">
            <div class="container" style="height: 100%;" v-if="is_page_init">
                <div class="row" style="height: 100%">
                    <div class="col" style="height: 100%">
                        <div class="text-center" style="height: 100%">
                            <div class="spinner-grow" role="status" style="margin-top:300px;color:#E7E7FF;">
                                <span class="visually-hidden">Loading...</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="wrap" v-else>
                <div class="container">
                    <div class="row justify-content-center">
                        <div class="col-8 text-center">
                            <div class="text-canter">
                                <a type="button" class="btn btn-luna" href="/user/icon"
                                    style="font-size:10px;background-color: #fff;border-color: #fff;color: #6b4eff;position: relative;top: 45px;"><i
                                        class="bi bi-camera"></i>&nbsp;編集</a>
                            </div>
                            <img src="/images/icon_user.png" style="width:100%;" class="icon_sub_box"
                                v-if="user.icon_url == null" />
                            <img :src="user.icon_url" style="width:100%;" class="icon_main_box" v-else />
                            <div style="margin:0 -10px -30px -10px;position: relative;top: -30px;"
                                v-if="user.can_use_all_features">
                                <div class="row ">
                                    <div class="col px-0">
                                        <div style="padding:5px;">
                                            <img src="/images/icon_user.png" style="width:100%;" class="icon_sub_box"
                                                v-if="user.sub_icon_url1 == null" />
                                            <img src="/images/icon_user.png" style="width:100%;" class="icon_sub_box"
                                                v-else-if="user.sub_icon_url1 == ''" />
                                            <img :src="user.sub_icon_url1" style="width:100%;" class="icon_sub_box"
                                                v-else />
                                        </div>
                                    </div>
                                    <div class="col px-0">
                                        <div style="padding:5px;">
                                            <img src="/images/icon_user.png" style="width:100%;" class="icon_sub_box"
                                                v-if="user.sub_icon_url2 == null" />
                                            <img src="/images/icon_user.png" style="width:100%;" class="icon_sub_box"
                                                v-else-if="user.sub_icon_url2 == ''" />
                                            <img :src="user.sub_icon_url2" style="width:100%;" class="icon_sub_box"
                                                v-else />
                                        </div>
                                    </div>
                                    <div class="col px-0">
                                        <div style="padding:5px;">
                                            <img src="/images/icon_user.png" style="width:100%;" class="icon_sub_box"
                                                v-if="user.sub_icon_url3 == null" />
                                            <img src="/images/icon_user.png" style="width:100%;" class="icon_sub_box"
                                                v-else-if="user.sub_icon_url3 == ''" />
                                            <img :src="user.sub_icon_url3" style="width:100%;" class="icon_sub_box"
                                                v-else />
                                        </div>
                                    </div>
                                    <div class="col px-0">
                                        <div style="padding:5px;">
                                            <img src="/images/icon_user.png" style="width:100%;" class="icon_sub_box"
                                                v-if="user.sub_icon_url4 == null" />
                                            <img src="/images/icon_user.png" style="width:100%;" class="icon_sub_box"
                                                v-else-if="user.sub_icon_url4 == ''" />
                                            <img :src="user.sub_icon_url4" style="width:100%;" class="icon_sub_box"
                                                v-else />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <br>
                    <div class="row justify-content-center">
                        <div class="col-8 text-center">
                            <div class="d-grid gap-2">
                                <a type="button" class="btn btn-luna-outline" style="font-size:12px;padding:10px 0;"
                                    href="/user/mod">
                                    <i class="bi bi-pencil-fill"></i>&nbsp;プロフィール内容を編集
                                </a>
                                <a type="button" class="btn btn-luna-outline" style="font-size:12px;padding:10px 0;"
                                    href="/card">
                                    <svg style="height:16px;width:16px;fill:#6B4EFF;">
                                        <use xlink:href="/images/card.svg#card"></use>
                                    </svg>&nbsp;好みのカードを選び直す
                                </a>
                            </div>
                        </div>
                    </div>
                    <br>
                    <div class="row">
                        <div class="col d-flex align-items-center">
                            <div class="luna-page-box-l">
                                <div style="font-size:20px;color:#6B4EFF;">{{ user.name }}</div>
                            </div>
                            <div class="text-center luna-page-box-r">
                                <img src="/images/Group12769.png" style="width:100%;" v-if="user.can_use_all_features_male" />
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col d-flex align-items-center">
                            <div class="luna-page-box-l">
                                <small>
                                    <div>
                                        <span style="">
                                            {{ sex_list[user.sex] }}｜
                                        </span>
                                        <span style="" v-if="user.age_view">
                                            {{ user.age }}｜
                                        </span>
                                        <span style="" v-else>
                                            秘密｜
                                        </span>
                                        <span style="">
                                            {{ area_list[user.area] }}｜
                                        </span>
                                        <span style="">
                                            @{{ user.luna_account }}｜
                                        </span>
                                        <span>
                                            LunaID: {{ user.id }}
                                        </span>
                                    </div>
                                    <p>
                                        Luna最終ログイン・{{
                                            user.last_login_at | loginStatus
                                        }}
                                    </p>
                                </small>
                            </div>
                            <div class="text-center luna-page-box-r">
                                <img src="/images/Group12901.png" style="width:100%;" v-if="user.is_ambassador" />
                            </div>
                        </div>
                    </div>
                    <br>
                    <div class="row" style="background:#E7E7FF;">
                        <div class="col" style="padding-top:10px;padding-bottom:10px">
                            <b>探している関係性</b>
                        </div>
                        <div class="col-4 text-end" style="padding-top:10px;">
                            <a href="/user/mod#1" style="text-decoration: underline;"><small>編集する</small></a>
                        </div>
                    </div>
                    <div class="row" style="padding-top:10px;padding-bottom:10px;">
                        <div class="col">
                            <div class="item-profile-box">
                                <div style="padding-top:10px;">
                                    <div :class="is_relationship_list_1 ? 'item-line-on' : 'item-line-off'">
                                        友達
                                    </div>
                                    <div :class="is_relationship_list_2 ? 'item-line-on' : 'item-line-off'">
                                        恋愛相手
                                    </div>
                                    <div :class="is_relationship_list_3 ? 'item-line-on' : 'item-line-off'">
                                        一時的なプレイの関係
                                    </div>
                                    <div :class="is_relationship_list_4 ? 'item-line-on' : 'item-line-off'">
                                        SMパートナー
                                    </div>
                                    <div :class="is_relationship_list_5 ? 'item-line-on' : 'item-line-off'">
                                        主従関係
                                    </div>
                                    <div :class="is_relationship_list_6 ? 'item-line-on' : 'item-line-off'">
                                        緊縛パートナー
                                    </div>
                                    <div :class="is_relationship_list_7 ? 'item-line-on' : 'item-line-off'">
                                        ディシスパのパートナー
                                    </div>
                                    <div :class="is_relationship_list_8 ? 'item-line-on' : 'item-line-off'">
                                        ぐりぐらのパートナー
                                    </div>
                                    <div :class="is_relationship_list_9 ? 'item-line-on' : 'item-line-off'">
                                        SM婚まで考えた関係
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row" style="background:#E7E7FF;">
                        <div class="col" style="padding-top:10px;padding-bottom:10px">
                            <b>好みのカード</b>
                        </div>
                    </div>
                    <div class="row justify-content-center" style="padding-top:10px;">
                        <div class="col-8 text-center">
                            <div class="d-grid gap-2">
                                <a type="button" class="btn btn-luna-outline" style="font-size:12px;padding:10px 0;"
                                    href="/card">
                                    <svg style="height:16px;width:16px;fill:#6B4EFF;">
                                        <use xlink:href="/images/card.svg#card"></use>
                                    </svg>&nbsp;好みのカードを選び直す
                                </a>
                            </div>
                        </div>
                    </div>
                    <div class="row" style="padding-top:10px;">
                        <div class="col">
                            <div class="item-profile-box">
                                <div style="padding-top:10px;">
                                    <div class="row">
                                        <div class="col-3 px-0" v-for="user_card in user_card_list" :key="user_card.id">
                                            <a :href="'/card/detail/' + user_card.id" style="color:#000;">
                                                <div style="margin:8px;">
                                                    <img :src="user_card.thumbnail_image" class="luna-rounded img-fluid">
                                                    <div><small>{{ user_card.name }}</small></div>
                                                </div>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                                <div style="padding-top:10px;" v-if="user_card_is_page && user_card_count != 0">
                                    <div class="row">
                                        <div class="col">
                                            <div class="text-center" style="color: #9990FF">
                                                <a @click="fetchUserCardsMore()">もっとみる</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <br>
                    <div class="row" style="background:#E7E7FF;">
                        <div class="col" style="padding-top:10px;padding-bottom:10px">
                            <b>{{ user.name }}さんの情報</b>
                        </div>
                    </div>
                    <div class="row" style="padding-top:10px;">
                        <div class="col">
                            <div class="row">
                                <div class="col"><b>自己紹介</b></div>
                                <div class="col-4 text-end">
                                    <a href="/user/mod#2" style="text-decoration: underline;"><small>編集する</small></a>
                                </div>
                            </div>
                            <div style="padding-top:10px;white-space: pre-wrap;">{{ user.profile }}</div>
                        </div>
                    </div>
                    <br>
                    <div class="row" style="background:#E7E7FF;">
                        <div class="col" style="padding-top:10px;padding-bottom:10px">
                        </div>
                    </div>
                    <div class="row" style="padding-top:10px;">
                        <div class="col">
                            <div class="row">
                                <div class="col"><b>基本情報</b></div>
                                <div class="col-4 text-end">
                                    <a href="/user/mod#3" style="text-decoration: underline;"><small>編集する</small></a>
                                </div>
                            </div>
                            <div style="padding-top:10px;">
                                <div class="row" style="padding-top:20px;">
                                    <div class="col-6" style="font-size:12px;color:#6B4EFF;">
                                        プライベートのパートナー
                                    </div>
                                    <div class="col" style="font-size:12px;">
                                        <div v-if="user.is_private_partner == 1">
                                            既婚者
                                        </div>
                                        <div v-else-if="user.is_private_partner == 2">
                                            彼氏/彼女がいる
                                        </div>
                                        <div v-else-if="user.is_private_partner == 3">
                                            フリー
                                        </div>
                                    </div>
                                </div>
                                <div class="row" style="padding-top:20px;">
                                    <div class="col-6" style="font-size:12px;color:#6B4EFF;">
                                        SMパートナー
                                    </div>
                                    <div class="col" style="font-size:12px;">
                                        <div v-if="user.is_smds_partner == 1">
                                            いない
                                        </div>
                                        <div v-else-if="user.is_smds_partner == 2">
                                            一人いる
                                        </div>
                                        <div v-else-if="user.is_smds_partner == 3">
                                            複数いる
                                        </div>
                                    </div>
                                </div>
                                <div class="row" style="padding-top:20px;">
                                    <div class="col-6" style="font-size:12px;color:#6B4EFF;">
                                        タバコ
                                    </div>
                                    <div class="col" style="font-size:12px;">
                                        <div v-if="user.is_smoking == 1">
                                            吸わない
                                        </div>
                                        <div v-else-if="user.is_smoking == 2">
                                            吸う
                                        </div>
                                        <div v-else-if="user.is_smoking == 3">
                                            吸う(電子タバコ)
                                        </div>
                                        <div v-else-if="user.is_smoking == 4">
                                            非喫煙者の前では吸わない
                                        </div>
                                        <div v-else-if="user.is_smoking == 5">
                                            時々吸う
                                        </div>
                                    </div>
                                </div>
                                <div class="row" style="padding-top:20px;">
                                    <div class="col-6" style="font-size:12px;color:#6B4EFF;">
                                        身長
                                    </div>
                                    <div class="col" style="font-size:12px;">
                                        <div v-if="user.body_height == 100">
                                            秘密
                                        </div>
                                        <div v-else-if="user.body_height == 129">
                                            130cm未満
                                        </div>
                                        <div v-else-if="user.body_height == 201">
                                            201cm以上
                                        </div>
                                        <div v-else-if="user.body_height == null">
                                            -
                                        </div>
                                        <div v-else>
                                            {{ user.body_height }}cm
                                        </div>
                                    </div>
                                </div>
                                <div class="row" style="padding-top:20px;">
                                    <div class="col-6" style="font-size:12px;color:#6B4EFF;">
                                        体型
                                    </div>
                                    <div class="col" style="font-size:12px;">
                                        <div v-if="user.body_type == 1">
                                            スリム
                                        </div>
                                        <div v-else-if="user.body_type == 2">
                                            やや細め
                                        </div>
                                        <div v-else-if="user.body_type == 3">
                                            普通
                                        </div>
                                        <div v-else-if="user.body_type == 4">
                                            グラマー
                                        </div>
                                        <div v-else-if="user.body_type == 5">
                                            筋肉質
                                        </div>
                                        <div v-else-if="user.body_type == 6">
                                            ややぽっちゃり
                                        </div>
                                        <div v-else-if="user.body_type == 7">
                                            太め
                                        </div>
                                    </div>
                                </div>
                                <div class="row" style="padding-top:20px;">
                                    <div class="col-6" style="font-size:12px;color:#6B4EFF;">
                                        SM経験
                                    </div>
                                    <div class="col" style="font-size:12px;">
                                        <div v-if="user.sm_year == 1">
                                            未経験
                                        </div>
                                        <div v-else-if="user.sm_year == 2">
                                            1年未満
                                        </div>
                                        <div v-else-if="user.sm_year == 3">
                                            1年〜3年
                                        </div>
                                        <div v-else-if="user.sm_year == 4">
                                            4年〜6年
                                        </div>
                                        <div v-else-if="user.sm_year == 5">
                                            7年〜10年
                                        </div>
                                        <div v-else-if="user.sm_year == 6">
                                            11年以上
                                        </div>
                                    </div>
                                </div>
                                <div class="row" style="padding-top:20px;">
                                    <div class="col-3" style="font-size:12px;color:#6B4EFF;">
                                        性癖タイプ
                                    </div>
                                    <div class="col">
                                        <img :src="user.my_type_img_url" class="img-fluid">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <br>
                    <div class="row" style="background:#E7E7FF;">
                        <div class="col" style="padding-top:10px;padding-bottom:10px">
                        </div>
                    </div>
                    <div class="row" style="padding-top:10px;">
                        <div class="col">
                            <div class="row">
                                <div class="col"><b>好みについて</b></div>
                                <div class="col-4 text-end">
                                    <a href="/user/mod#4" style="text-decoration: underline;"><small>編集する</small></a>
                                </div>
                            </div>
                            <div style="padding-top:10px;">
                                <div class="row" style="padding-top:10px;">
                                    <div class="col-5" style="font-size:12px;color:#6B4EFF;">

                                    </div>
                                    <div class="col" style="font-size:12px;color:#6B4EFF;">
                                        <img src="/images/Group13205.png" class="img-fluid">
                                    </div>
                                </div>
                                <div class="row" style="padding-top:10px;">
                                    <div class="col-5" style="font-size:12px;color:#6B4EFF;">
                                        SEXについて
                                    </div>
                                    <div class="col" style="font-size:12px;color:#6B4EFF;">
                                        <img src="/images/line_1.png" class="img-fluid" v-if="user.q_sex == 1">
                                        <img src="/images/line_2.png" class="img-fluid" v-else-if="user.q_sex == 2">
                                        <img src="/images/line_3.png" class="img-fluid" v-else-if="user.q_sex == 3">
                                        <img src="/images/line_4.png" class="img-fluid" v-else-if="user.q_sex == 4">
                                        <img src="/images/line_5.png" class="img-fluid" v-else-if="user.q_sex == 5">
                                    </div>
                                </div>
                                <div class="row" style="padding-top:20px;">
                                    <div class="col-5" style="font-size:12px;color:#6B4EFF;">
                                        苦痛について
                                    </div>
                                    <div class="col" style="font-size:12px;color:#6B4EFF;">
                                        <img src="/images/line_1.png" class="img-fluid" v-if="user.q_pain == 1">
                                        <img src="/images/line_2.png" class="img-fluid" v-else-if="user.q_pain == 2">
                                        <img src="/images/line_3.png" class="img-fluid" v-else-if="user.q_pain == 3">
                                        <img src="/images/line_4.png" class="img-fluid" v-else-if="user.q_pain == 4">
                                        <img src="/images/line_5.png" class="img-fluid" v-else-if="user.q_pain == 5">
                                    </div>
                                </div>
                                <div class="row" style="padding-top:20px;">
                                    <div class="col-5" style="font-size:12px;color:#6B4EFF;">
                                        精神的な束縛/苦痛
                                    </div>
                                    <div class="col" style="font-size:12px;color:#6B4EFF;">
                                        <img src="/images/line_1.png" class="img-fluid" v-if="user.q_dom == 1">
                                        <img src="/images/line_2.png" class="img-fluid" v-else-if="user.q_dom == 2">
                                        <img src="/images/line_3.png" class="img-fluid" v-else-if="user.q_dom == 3">
                                        <img src="/images/line_4.png" class="img-fluid" v-else-if="user.q_dom == 4">
                                        <img src="/images/line_5.png" class="img-fluid" v-else-if="user.q_dom == 5">
                                    </div>
                                </div>
                                <div class="row" style="padding-top:20px;">
                                    <div class="col-5" style="font-size:12px;color:#6B4EFF;">
                                        物理的な拘束について
                                    </div>
                                    <div class="col" style="font-size:12px;color:#6B4EFF;">
                                        <img src="/images/line_1.png" class="img-fluid" v-if="user.q_restraint == 1">
                                        <img src="/images/line_2.png" class="img-fluid" v-else-if="user.q_restraint == 2">
                                        <img src="/images/line_3.png" class="img-fluid" v-else-if="user.q_restraint == 3">
                                        <img src="/images/line_4.png" class="img-fluid" v-else-if="user.q_restraint == 4">
                                        <img src="/images/line_5.png" class="img-fluid" v-else-if="user.q_restraint == 5">
                                    </div>
                                </div>
                                <div class="row" style="padding-top:20px;">
                                    <div class="col-5" style="font-size:12px;color:#6B4EFF;">
                                        羞恥について
                                    </div>
                                    <div class="col" style="font-size:12px;color:#6B4EFF;">
                                        <img src="/images/line_1.png" class="img-fluid" v-if="user.q_shame == 1">
                                        <img src="/images/line_2.png" class="img-fluid" v-else-if="user.q_shame == 2">
                                        <img src="/images/line_3.png" class="img-fluid" v-else-if="user.q_shame == 3">
                                        <img src="/images/line_4.png" class="img-fluid" v-else-if="user.q_shame == 4">
                                        <img src="/images/line_5.png" class="img-fluid" v-else-if="user.q_shame == 5">
                                    </div>
                                </div>
                                <div class="row" style="padding-top:20px;">
                                    <div class="col-5" style="font-size:12px;color:#6B4EFF;">
                                        快楽について
                                    </div>
                                    <div class="col" style="font-size:12px;color:#6B4EFF;">
                                        <img src="/images/line_1.png" class="img-fluid" v-if="user.q_pleasure == 1">
                                        <img src="/images/line_2.png" class="img-fluid" v-else-if="user.q_pleasure == 2">
                                        <img src="/images/line_3.png" class="img-fluid" v-else-if="user.q_pleasure == 3">
                                        <img src="/images/line_4.png" class="img-fluid" v-else-if="user.q_pleasure == 4">
                                        <img src="/images/line_5.png" class="img-fluid" v-else-if="user.q_pleasure == 5">
                                    </div>
                                </div>
                                <div class="row" style="padding-top:20px;">
                                    <div class="col-5" style="font-size:12px;color:#6B4EFF;">
                                        依存について
                                    </div>
                                    <div class="col" style="font-size:12px;color:#6B4EFF;">
                                        <img src="/images/line_1.png" class="img-fluid" v-if="user.q_reliance == 1">
                                        <img src="/images/line_2.png" class="img-fluid" v-else-if="user.q_reliance == 2">
                                        <img src="/images/line_3.png" class="img-fluid" v-else-if="user.q_reliance == 3">
                                        <img src="/images/line_4.png" class="img-fluid" v-else-if="user.q_reliance == 4">
                                        <img src="/images/line_5.png" class="img-fluid" v-else-if="user.q_reliance == 5">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <br>
                    <div class="row" style="background:#E7E7FF;">
                        <div class="col" style="padding-top:10px;padding-bottom:10px">
                        </div>
                    </div>
                    <div class="row" style="padding-top:10px;">
                        <div class="col">
                            <div class="row">
                                <div class="col"><b>嗜好について</b></div>
                                <div class="col-4 text-end">
                                    <a href="/user/mod#5" style="text-decoration: underline;"><small>編集する</small></a>
                                </div>
                            </div>
                            <div style="color:#333333;padding-top:10px;white-space: pre-wrap;">{{ user.text_my_like }}</div>
                        </div>
                    </div>
                    <br>
                    <div class="row" style="background:#E7E7FF;">
                        <div class="col" style="padding-top:10px;padding-bottom:10px">
                        </div>
                    </div>
                    <div class="row" style="padding-top:10px;">
                        <div class="col">
                            <div class="row">
                                <div class="col"><b>NGについて</b></div>
                                <div class="col-4 text-end">
                                    <a href="/user/mod#6" style="text-decoration: underline;"><small>編集する</small></a>
                                </div>
                            </div>
                            <div style="color:#333333;padding-top:10px;white-space: pre-wrap;">{{ user.text_my_ng }}</div>
                        </div>
                    </div>
                    <br>
                    <div class="row" style="background:#E7E7FF;">
                        <div class="col" style="padding-top:10px;padding-bottom:10px">
                            <div class="item-profile-con-box">
                                <div class="row">
                                    <div class="col"><b>相手に求める条件</b></div>
                                    <div class="col-4 text-end">
                                        <a href="/user/mod#7" style="text-decoration: underline;"><small>編集する</small></a>
                                    </div>
                                </div>
                                <div style="padding-top:10px;white-space: pre-wrap;">{{ user.conditions_text }}</div>
                                <div style="padding-top:10px;">
                                    <div class="row" style="padding-top:20px;">
                                        <div class="col-3" style="font-size:12px;color:#6B4EFF;white-space: nowrap;">
                                            求める<br>性癖タイプ
                                        </div>
                                        <div class="col">
                                            <img :src="user.conditions_type_img_url" class="img-fluid">
                                        </div>
                                    </div>
                                    <div class="row" style="padding-top:20px;">
                                        <div class="col-6" style="font-size:12px;color:#6B4EFF">
                                            性対象
                                        </div>
                                        <div class="col-6" style="font-size:12px;">
                                            {{ user.conditions_sex_text }}
                                        </div>
                                    </div>
                                    <div class="row" style="padding-top:20px;">
                                        <div class="col-6" style="font-size:12px;color:#6B4EFF">
                                            年齢
                                        </div>
                                        <div class="col-6" style="font-size:12px;">
                                            <div v-if="user.conditions_age_from != null || user.conditions_age_to != null">
                                                {{ age_list[user.conditions_age_from] }}〜{{ age_list[user.conditions_age_to]
                                                }}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row" style="padding-top:20px;">
                                        <div class="col-6" style="font-size:12px;color:#6B4EFF">
                                            地域
                                        </div>
                                        <div class="col-6" style="font-size:12px;">
                                            {{ user.conditions_area_text }}
                                        </div>
                                    </div>
                                    <div class="row" style="padding-top:20px;">
                                        <div class="col-6" style="font-size:12px;color:#6B4EFF">
                                            体型
                                        </div>
                                        <div class="col-6" style="font-size:12px;">
                                            {{ user.conditions_body_text }}
                                        </div>
                                    </div>
                                    <div class="row" style="padding-top:20px;">
                                        <div class="col-6" style="font-size:12px;color:#6B4EFF">
                                            プライベートのパートナー
                                        </div>
                                        <div class="col-6" style="font-size:12px;">
                                            {{ user.conditions_is_private_partner_text }}
                                        </div>
                                    </div>
                                    <div class="row" style="padding-top:20px;">
                                        <div class="col-6" style="font-size:12px;color:#6B4EFF">
                                            SM経験
                                        </div>
                                        <div class="col-6" style="font-size:12px;">
                                            {{ user.conditions_is_sm_text }}
                                        </div>
                                    </div>
                                    <div class="row" style="padding-top:20px;">
                                        <div class="col-6" style="font-size:12px;color:#6B4EFF">
                                            関係性
                                        </div>
                                        <div class="col-6" style="font-size:12px;">
                                            <div class="col" v-if="user.conditions_real_net == 1">
                                                リアル必須
                                            </div>
                                            <div class="col" v-else-if="user.conditions_real_net == 2">
                                                ネットのみ
                                            </div>
                                            <div class="col" v-else-if="user.conditions_real_net == 3">
                                                どちらでもよい
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <br>
                <br>
                <br>
                <br>
            </div>
            <FooterMenu />
        </div>
    </div>
</template>

<script>
import FooterMenu from '../components/FooterMenu.vue';

export default {
    components: {
        FooterMenu
    },
    data() {
        return {
            user: [],
            area_list: [],
            age_list: [],
            sex_list: [],
            tab: 1,
            iconUrlCroppa: null,
            file: null,
            is_load: false,
            type: "",
            a: false,
            b: false,
            c: false,
            d: false,
            e: false,
            f: false,
            g: false,
            h: false,
            i: false,
            j: false,
            k: false,
            l: false,
            m: false,
            n: false,
            o: false,
            p: false,
            q: false,
            r: false,
            s: false,
            t: false,
            u: false,
            v: false,
            con_a: false,
            con_b: false,
            con_c: false,
            con_d: false,
            con_e: false,
            con_f: false,
            con_g: false,
            con_h: false,
            con_i: false,
            con_j: false,
            con_k: false,
            con_l: false,
            con_m: false,
            con_n: false,
            con_o: false,
            con_p: false,
            con_q: false,
            con_r: false,
            con_s: false,
            con_t: false,
            con_u: false,
            con_v: false,
            is_page_init: true,
            is_relationship_list_1: false,
            is_relationship_list_2: false,
            is_relationship_list_3: false,
            is_relationship_list_4: false,
            is_relationship_list_5: false,
            is_relationship_list_6: false,
            is_relationship_list_7: false,
            is_relationship_list_8: false,
            is_relationship_list_9: false,
            user_card_list: [],
            user_card_count: 0,
            user_card_page: 1,
            user_card_is_load: true,
            user_card_is_page: true,
        };
    },
    methods: {
        async init() {
            await axios.get("/api/auth/user/get")
                .then(
                    (response) => {
                        this.fetchUsers()
                    }
                )
                .catch((error) => {
                    if (error.response && error.response.status == 401) {
                        window.location.href = "/auth?logout=true"
                    }
                    else {
                        this.$showErrorToast("ユーザーの取得に失敗しました")
                    }
                })
        },
        async fetchUsers() {
            await axios.get("/api/user/get/me")
                .then((response) => {
                    this.user = response.data.user
                    this.area_list = response.data.area_list
                    this.age_list = response.data.age_list
                    this.sex_list = response.data.sex_list

                    this.a = (this.user.my_types.indexOf('A') !== -1)
                    this.b = (this.user.my_types.indexOf('B') !== -1)
                    this.c = (this.user.my_types.indexOf('C') !== -1)
                    this.d = (this.user.my_types.indexOf('D') !== -1)
                    this.e = (this.user.my_types.indexOf('E') !== -1)
                    this.f = (this.user.my_types.indexOf('F') !== -1)
                    this.g = (this.user.my_types.indexOf('G') !== -1)
                    this.h = (this.user.my_types.indexOf('H') !== -1)
                    this.i = (this.user.my_types.indexOf('I') !== -1)
                    this.j = (this.user.my_types.indexOf('J') !== -1)
                    this.k = (this.user.my_types.indexOf('K') !== -1)
                    this.l = (this.user.my_types.indexOf('L') !== -1)
                    this.m = (this.user.my_types.indexOf('M') !== -1)
                    this.n = (this.user.my_types.indexOf('N') !== -1)
                    this.o = (this.user.my_types.indexOf('O') !== -1)
                    this.p = (this.user.my_types.indexOf('P') !== -1)
                    this.q = (this.user.my_types.indexOf('Q') !== -1)
                    this.r = (this.user.my_types.indexOf('R') !== -1)
                    this.s = (this.user.my_types.indexOf('S') !== -1)
                    this.t = (this.user.my_types.indexOf('T') !== -1)
                    this.u = (this.user.my_types.indexOf('U') !== -1)
                    this.v = (this.user.my_types.indexOf('V') !== -1)

                    this.con_a = (this.user.conditions_types.indexOf('A') !== -1)
                    this.con_b = (this.user.conditions_types.indexOf('B') !== -1)
                    this.con_c = (this.user.conditions_types.indexOf('C') !== -1)
                    this.con_d = (this.user.conditions_types.indexOf('D') !== -1)
                    this.con_e = (this.user.conditions_types.indexOf('E') !== -1)
                    this.con_f = (this.user.conditions_types.indexOf('F') !== -1)
                    this.con_g = (this.user.conditions_types.indexOf('G') !== -1)
                    this.con_h = (this.user.conditions_types.indexOf('H') !== -1)
                    this.con_i = (this.user.conditions_types.indexOf('I') !== -1)
                    this.con_j = (this.user.conditions_types.indexOf('J') !== -1)
                    this.con_k = (this.user.conditions_types.indexOf('K') !== -1)
                    this.con_l = (this.user.conditions_types.indexOf('L') !== -1)
                    this.con_m = (this.user.conditions_types.indexOf('M') !== -1)
                    this.con_n = (this.user.conditions_types.indexOf('N') !== -1)
                    this.con_o = (this.user.conditions_types.indexOf('O') !== -1)
                    this.con_p = (this.user.conditions_types.indexOf('P') !== -1)
                    this.con_q = (this.user.conditions_types.indexOf('Q') !== -1)
                    this.con_r = (this.user.conditions_types.indexOf('R') !== -1)
                    this.con_s = (this.user.conditions_types.indexOf('S') !== -1)
                    this.con_t = (this.user.conditions_types.indexOf('T') !== -1)
                    this.con_u = (this.user.conditions_types.indexOf('U') !== -1)
                    this.con_v = (this.user.conditions_types.indexOf('V') !== -1)

                    if (this.user.relationship !== null) {
                        const relationships = this.user.relationship.toString().split(',');
                        this.is_relationship_list_1 = relationships.includes("1");
                        this.is_relationship_list_2 = relationships.includes("2");
                        this.is_relationship_list_3 = relationships.includes("3");
                        this.is_relationship_list_4 = relationships.includes("4");
                        this.is_relationship_list_5 = relationships.includes("5");
                        this.is_relationship_list_6 = relationships.includes("6");
                        this.is_relationship_list_7 = relationships.includes("7");
                        this.is_relationship_list_8 = relationships.includes("8");
                        this.is_relationship_list_9 = relationships.includes("9");
                    }

                    this.is_page_init = false
                    this.fetchUserCards()
                })
                .catch((error) => {
                    if (error.response && error.response.status == 401) {
                        window.location.href = "/auth?logout=true"
                    }
                    else {
                        this.$showErrorToast("ユーザーの取得に失敗しました")
                    }
                })
        },
        async fetchUserCards() {
            await axios.get("/api/user/your/card/get/" + this.user.id)
                .then((response) => {
                    this.user_card_list = response.data.user_card_list.data
                    this.user_card_count = response.data.user_card_count

                    if (this.user_card_count <= 8) {
                        this.user_card_is_page = false
                    }

                })
                .catch((error) => {
                    if (error.response && error.response.status == 401) {
                        window.location.href = "/auth?logout=true"
                    }
                    else {
                        this.$showErrorToast("カードの取得に失敗しました")
                    }
                }).finally(() => {
                    this.user_card_is_load = false
                })
        },
        async fetchUserCardsMore() {
            this.user_card_page++

            await axios.get("/api/user/your/card/get/" + this.user.id + "?page=" + this.user_card_page)
                .then((response) => {
                    this.user_card_list.push.apply(this.user_card_list, response.data.user_card_list.data)

                    if (response.data.user_card_list.data.length == 0) {
                        this.user_card_is_page = false
                    }
                })
                .catch((error) => {
                    if (error.response && error.response.status == 401) {
                        window.location.href = "/auth?logout=true"
                    }
                    else {
                        this.$showErrorToast("カードの取得に失敗しました")
                    }
                })
        },
        showIconUrl(t) {
            window.location.href = "/user/icon/" + this.user.id + "/1"
        },
    },
    async created() {

        // 自動ログインチェック
        var arr = new Array();
        if (document.cookie != '') {
            var tmp = document.cookie.split('; ');
            for (var i = 0; i < tmp.length; i++) {
                var data = tmp[i].split('=');
                arr[data[0]] = decodeURIComponent(data[1]);
            }

            if (arr['uid'] != undefined) {
                await axios.get("/api/user/auth/" + arr['uid'])
                    .then(
                        (response) => {
                            this.init()
                            let _tab = this.$route.query.tab != undefined ? this.$route.query.tab : 1
                            this.tab = _tab
                        })
                    .catch((error) => {
                        this.$showErrorToast("ユーザーの取得に失敗しました")
                    })
            }
            else {
                this.init()
                let _tab = this.$route.query.tab != undefined ? this.$route.query.tab : 1
                this.tab = _tab
            }
        }
        else {
            this.init()
            let _tab = this.$route.query.tab != undefined ? this.$route.query.tab : 1
            this.tab = _tab
        }
    },
    filters: {
        loginStatus(login_at) {
            let status = "数秒前"

            let dt = new Date()
            let lg = new Date(login_at)

            //lg.setHours(lg.getHours() + 9)

            var diff = dt.getTime() - lg.getTime()
            //分
            var minutes = Math.floor(diff / (60 * 1000))
            //時
            var hour = Math.floor(diff / (60 * 60 * 1000))
            //日
            var day = Math.floor(diff / (1000 * 60 * 60 * 24))

            if (day == 0 && hour == 0 && minutes > 0) {
                status = minutes + "分前"
            } else if (day == 0 && hour > 0) {
                status = hour + "時間前"
            } else if (day > 0 && day < 31) {
                status = day + "日前"
            } else if (day > 30) {
                status = "30日以上前"
            }

            return status
        },
    },
}
</script>
<style scoped>
.luna-header-box {
    position: fixed;
    height: 46px;
    width: 540px;
    top: 0;
    background-color: #fff;
    z-index: 999;
}

@media (max-width: 576px) {
    .luna-header-box {
        width: 100%;
    }
}

.luna-page-profile-header {
    background-color: #E7E7FF;
    color: #6B4EFF;
    padding: 10px 20px;
    font-size: 18px;
}

.icon_main_box {
    border-radius: 20px;
    box-shadow: 0px 0px 20px -5px rgba(0, 0, 0, 0.35);
}

.icon_sub_box {
    border-radius: 5px;
}

.item-profile-box {
    background: #FFFFFF;
}

.item-line-on {
    float: left;
    margin-right: 2px;
    margin-bottom: 2px;
    border-radius: 20px;
    padding: 3px 10px;
    color: #fff;
    font-size: 11px;
    background-color: #9990FF;
}

.item-line-off {
    float: left;
    margin-right: 2px;
    margin-bottom: 2px;
    border-radius: 20px;
    padding: 3px 10px;
    color: #CDCDCD;
    font-size: 11px;
    background-color: #F2F2F2;
}

.item-profile-con-box {
    overflow: hidden;
    padding: 15px 20px;
    background: #FFFFFF;
    border-radius: 20px;
}

.type_box {
    position: relative;
    display: inline-block;
}

.type_box img {
    display: block;
    max-width: 100%;
    height: auto;
}

.type_box img.type_icon {
    position: absolute;
    width: 10%;
    height: auto;
    cursor: pointer;
}

.type_box img.type_icon_big {
    position: absolute;
    width: 32%;
    height: auto;
    cursor: pointer;
}

.type_box img.type_icon_out {
    position: absolute;
    width: 25%;
    height: auto;
    cursor: pointer;
}
</style>
